import { useBreakpoints } from "@/components/screen"
import FooterContentBlock from "@/pages/website-landing/components/footer/footer-content-block/FooterContentBlock"
import FooterLegalNote from "@/pages/website-landing/components/footer/footer-legal-note/FooterLegalNote"
import { EASETECH } from "@/utilities/global-variables"
import classnames from "classnames"
import { FC } from "react"
import { useLocation, useNavigate } from "react-router"
import sectionBg from "./images/footer-bg.webp"
import logoWhite from "./images/logo_company-white.png"

import MobileFooter from "@/pages/website-landing/components/footer/mobile-footer/MobileFooter"
import "./Footer.less"
import FooterSocialButtons from "./footer-social-buttons/FooterSocialButtons"

type FooterProps = {
  isOrgFooter?: boolean
}

const Footer: FC<FooterProps> = ({ isOrgFooter }) => {
  const { isXxl, isXl, isLg } = useBreakpoints()
  const navigate = useNavigate()

  // const params = useParams()
  // const currentOrgSlug = params.org

  const isSingleSubmission = useLocation().pathname.includes("single-submission")
  const isDesktopFooter = isXxl || isXl || isLg
  const showMobileFooter = !isSingleSubmission && !isOrgFooter

  const footerStyles = classnames({
    "footer-section-content": true,
    "partners-channel-content": isSingleSubmission || isOrgFooter,
    "org-footer-content": isOrgFooter,
  })

  return (
    <>
      <div className={`footer-section-wrapper ${isOrgFooter ? "org-footer-wrapper" : ""}`} id={"footer-section"}>
        <div className={"footer-bg-wrapper"}>
          <img src={sectionBg} alt={""} loading={"lazy"} decoding={"async"} />
        </div>

        {isDesktopFooter ? (
          <div className={footerStyles}>
            <div className={"logo-block"}>
              <div className={"logo-wrapper"}>
                <img src={logoWhite} alt={""} loading={"lazy"} decoding={"async"} />
              </div>

              {!isOrgFooter && <FooterSocialButtons />}
              <FooterLegalNote isOrgFooter={isOrgFooter} isSingleSubmission={isSingleSubmission} />
            </div>

            {!isSingleSubmission && !isOrgFooter && <FooterContentBlock />}
          </div>
        ) : isOrgFooter || isSingleSubmission ? (
          <div className={footerStyles}>
            <div className={"logo-block"}>
              <div className={"logo-wrapper"} onClick={() => navigate(`/${EASETECH}/home`)}>
                <img src={logoWhite} alt={""} loading={"lazy"} decoding={"async"} />
              </div>

              {isSingleSubmission && <FooterSocialButtons />}

              <FooterLegalNote isOrgFooter={isOrgFooter} isSingleSubmission={isSingleSubmission} />
            </div>
          </div>
        ) : (
          <MobileFooter />
        )}
      </div>
    </>
  )
}

export default Footer
